<template>
  <el-button type="primary" link @click="handleCode"> 推广码 </el-button>

  <!-- 推广码弹窗 -->
  <v-dialog v-model:visible="isShowBox" title="推广" width="30%" :type="1">
    <el-row justify="center">
      <div class="img-box">
        <img :src="imgUrl" alt="" />
      </div>
      <a :href="imgUrl" download="推广码"> 下载二维码 </a>
    </el-row>
  </v-dialog>
</template>
<script setup lang="ts">
import { ref, getCurrentInstance } from "vue";
import instance from "@/api/request";

interface Props {
  param: any;
  url: string;
  method: string;
}
const props = withDefaults(defineProps<Props>(), {
  param: () => {
    return {};
  },
  url: "",
  method: "get",
});

const app = getCurrentInstance()?.proxy;

/**
 *  获取二维码
 */
const isShowBox = ref(false);
const handleCode = () => {
  isShowBox.value = true;
  init();
};

/**
 *  获取二维码接口
 */
const imgUrl = ref("");
const init = () => {
  const dt =
    props.method == "get"
      ? {
          params: props.param,
        }
      : props.param;

  instance[props.method](props.url, dt).then((res: any) => {
    console.log(res);
    if (res.code == 200) {
      imgUrl.value = res.data.photo;
    } else {
      app?.$message.error(res.message);
    }
  });
};
</script>
<style scoped lang="scss">
a {
  color: #5893f5 !important;
}
.img-box {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}
img {
  width: 200px;
  height: 200px;
}
:deep(.el-row) {
  flex-wrap: wrap;
}
</style>
